module.exports = __webpack_public_path__ + "static/media/profile1.8eae4800.png";